const specialCommissions = {
  "LUNGHITANO SANTIAGO": ["12% de capital"],
  "COVELLI FRANCISCO": ["12% de capital"],
  FINGURU: ["5% de capital"],
  "RIVAROLA PAOLA": ["13% de capital"],
  FINMARVI: ["13% de capital"],
  "STABILE JORGELINA ROSA": ["13% de capital"],
  "SUC. FEDALAK": ["8% de capital"],
  "IBARRA JUAN": [
    "-Hasta $ 9.000.000 de capital 8%",
    "-Desde $ 9.000.001 hasta $ 12.000.000 de capital 10%",
    "-En adelante 12%",
  ],

  // Nuevos nombres con 8% de capital
  "SANCHEZ MARTA ITATI": ["8% de capital"],
  "ACUÑA CARLOS HORACIO": ["8% de capital"],
  "SEQUEIRA MIGUEL ANGEL": ["8% de capital"],
  "FRONTERA RAUL": ["8% de capital"],
  "FRANCO RICARDO": ["8% de capital"],
  "GOROSITO LUIS": ["8% de capital"],
  "IMBERT JUAN JOSE": ["8% de capital"],
  "PENA EDUARDO": ["8% de capital"],
  "NIETO FABIAN": ["8% de capital"],
  "JORGE CESAR RICARDO": ["8% de capital"],
  "WELSCHEN DAMIAN DARIO": ["8% de capital"],
  "BAZAN GERMAN": ["8% de capital"],
  "RACIOPPE MARIA ESTER": ["8% de capital"],
  "JANS ARIEL": ["8% de capital"],
  "CASTRO ANGEL": ["8% de capital"],
  "ROMAN NICOLAS EMANUEL": ["8% de capital"],
  "CEJAS JONATAN DAVID": ["8% de capital"],
  "GERBAN EMILIANO": ["8% de capital"],
  "CEJAS LUCAS": ["8% de capital"],
  "BARBIERI CRISTIAN": ["8% de capital"],
  "CENTURION EMANUEL": ["8% de capital"],
  "DUARTE EMILIANO": ["8% de capital"],
  "FEDERICO RODRIGUEZ": ["8% de capital"],
  "DIAZ EMANUEL": ["8% de capital"],
  "IGNACIO VEGA": ["8% de capital"],
  "VIDAL PATTE BAUTISTA": ["8% de capital"],
  "DUPIN SEBASTIAN": ["8% de capital"],
  "DE CLEMENTI SILVIA YOLANDA": ["8% de capital"],
  "DIAZ RIZZARDI EDUARDO": ["8% de capital"],
  "PATTE LAURA": ["8% de capital"],
  "SANCHEZ MATIAS": ["8% de capital"],
  "CEJAS JESICA": ["8% de capital"],
  "MONICA ALMIRON": ["8% de capital"],
  "DA COSTA SILVIA": ["8% de capital"],
  "VIDAL ALEJANDRA": ["8% de capital"],
  "GUSMAN BETINA": ["8% de capital"],
  "OUTEDA NANCY": ["8% de capital"],
  "FRAGUEIRO MARIANA": ["8% de capital"],
  "CAROLINA MORANTE": ["8% de capital"],
  "CASTROMAN LAURA": ["8% de capital"],
  "CAPONE CARLA": ["8% de capital"],
  "PEREYRA ROMINA": ["8% de capital"],
  "CORIA ALEJANDRA ELIZABETH": ["8% de capital"],
  "GOMEZ NATALIA": ["8% de capital"],
  "BASUALDO LAURA": ["8% de capital"],
  "KOLONIA MELINA ANTONELA": ["8% de capital"],
  "SANCHEZ MARIA BELEN": ["8% de capital"],
  "CEJAS JOANA": ["8% de capital"],
  "D AMBROSIO VALERIA": ["8% de capital"],
  "CANDELA PENA": ["8% de capital"],
  "VIDAL PATTE LUCIANA": ["8% de capital"],
  "DIAZ NATALY": ["8% de capital"],
  "BARBARO YASMINA": ["8% de capital"],
};

const defaultCommission = [
  "-Hasta $ 9.000.000 de capital 7%",
  "-Desde $ 9.000.001 hasta $ 12.000.000 de capital 9%",
  "-En adelante 11%",
];

const normalize = (str) => str.trim().toUpperCase();

export const getCommissionDisplay = (supplierName) => {
  const normalizedSupplierName = normalize(supplierName);
  return specialCommissions[normalizedSupplierName] || defaultCommission;
};
